<template>
  <v-app dark>
    <v-main>
      <router-view/>
      <msp-annuncio-ui></msp-annuncio-ui>
      <msp-richiesta-abbinamento v-if="isAtleta"></msp-richiesta-abbinamento>
      <msp-ricollega-garmin v-if="isAtleta"></msp-ricollega-garmin>
    </v-main>
  </v-app>


</template>

<style lang="scss">
@import "./scss/main.scss";
.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>

<script>
import MspAnnuncioUi from "@components/MspAnnuncioUi.vue";
import MspRichiestaAbbinamento from "@components/MspRichiestaAbbinamento.vue";
import MspRicollegaGarmin from "@components/MspRicollegaGarmin.vue";

export default {
    components: {
        MspAnnuncioUi,
        MspRichiestaAbbinamento,
        MspRicollegaGarmin,
    },
    computed: {
        // monta il dialog solo dopo il login, altrimenti la richiesta parte
        // dalla pagina di login e non viene mai ripetuta
        isAtleta() {
            const utente = this.$store.getters['utente/utente'];
            return !!(utente && utente.is_atleta);
        },
    },
};
</script>
